import { ViewType } from '~/constants/sem';
import { useIsMobile } from '~/context/common/DeviceContext';
import SemImageSource from '~/contracts/sem/SemImageSource';

export default function useImageViews(
  imageViews: Array<ViewType> | null | undefined,
  image: SemImageSource | null | undefined
) {
  const isMobile = useIsMobile();

  return {
    shouldShowImageOnMobile:
      (imageViews && imageViews.includes(ViewType.Mobile) && isMobile) || false,
    shouldShowImageOnDesktop:
      (imageViews && imageViews.includes(ViewType.Desktop) && !isMobile) ||
      false,
    imageUrl: (isMobile ? image?.mobile : image?.desktop) ?? ''
  };
}
